import { NotificationsApi } from '@/api';
import { Notification } from '@/models';
import { Module } from 'vuex';
import { Actions } from './actions';
import { Mutations } from './mutations';
import { RootState } from './root.store';

const notificationsApi = new NotificationsApi();

export interface NotificationsState {
  items: Notification[];
}

export const NotificationsModule: Module<NotificationsState, RootState> = {
  state: {
    items: [],
  },

  mutations: {
    [Mutations.notifications.set](state, notifications: Notification[]): void {
      state.items = notifications;
    },
  },

  actions: {
    async [Actions.notifications.fetch]({ commit }): Promise<void> {
      const notifications = await notificationsApi.getAll();
      commit(Mutations.notifications.set, notifications);
    },
    async [Actions.notifications.markAsRead](_, idList: string[]): Promise<void> {
      return await notificationsApi.markAsRead(idList);
    },
  },
};
